import { CheckmarkFilled16 } from '@carbon/icons-react';
import styled from 'styled-components';

type Props = {
  isEmpty?: boolean;
};

export const IconCell = (props: Props) => {
  return (
    <td>
      <IconContainer>{props.isEmpty ? <Empty /> : <CheckmarkFilled16 />}</IconContainer>
    </td>
  );
};

const IconContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Empty = styled.div`
  width: 16px;
  height: 16px;
`;
